const config = {
  apiBaseUrl: 'https://api-fcd.fcdallas.com',
  timeZone: 'America/New_York',
};

export default config;
